import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { AuthCallback } from "@/pages/AuthCallback";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Catalog from "@/pages/Catalog";
import VehicleDetail from "@/pages/VehicleDetail";
import Calculator from "@/pages/Calculator";
import GuidedChoice from "@/pages/GuidedChoice";
import Compare from "@/pages/Compare";
import HillClimb from "@/pages/HillClimb";
import Paywall from "@/pages/Paywall";
import Admin from "@/pages/Admin";
import { StaticPage } from "@/pages/StaticPage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

      <Route element={<Layout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/katalog" element={<Catalog />} />
        <Route path="/bantu-memilih" element={<GuidedChoice />} />
        <Route path="/kendaraan/:id" element={<VehicleDetail />} />
        <Route path="/premium" element={<Paywall />} />
        <Route path="/tentang" element={<StaticPage slug="tentang" />} />
        <Route path="/kontak" element={<StaticPage slug="kontak" />} />
        <Route path="/metodologi" element={<StaticPage slug="metodologi" />} />
        <Route path="/privasi" element={<StaticPage slug="privasi" />} />
        <Route path="/syarat" element={<StaticPage slug="syarat" />} />

        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/hitung" element={<ProtectedRoute><Calculator /></ProtectedRoute>} />
        <Route path="/tanjakan" element={<ProtectedRoute><HillClimb /></ProtectedRoute>} />
        <Route path="/bandingkan" element={<ProtectedRoute><Compare /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
